import ADD_REGISTER_FORM_DATA from './addRegisterFormData';
import ADD_SUBSCRIPTION_FORM_DATA from './addSubscriptionFormData';

export const mutationDictionary = {
    ADD_REGISTER_FORM_DATA,
    ADD_SUBSCRIPTION_FORM_DATA,
};

export default mutationDictionary;
